import config from '@/assets/config.json';
import api from '../../api/index';

const state = {
    userInfo: {
        id: '',
        name: ''
    }
}
const mutations = {

}
const getters = {

}
const actions = {

    // 通联注册地址
    getRegisterUrlApi({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.userHttps.api}/apimerchant/users/registerallin`, opt,{headers:{
                Authorization:'Bearer '+localStorage.getItem("Beitoken")
              }},).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },
    // 密码登录
    passwordLogin({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.userHttps.api}/apiuser/login/passwdlogin`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },

    // 校验图片验证码
    postCheckImg({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.userHttps.api}/apiuser/login/checkimg`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },

    // 获取验证码图片地址
    getLoginImgCode() {
        return new Promise((resolve, reject) => {
            api.post(`${config.userHttps.api}/apiuser/login/getimg`)
                .then(data => {
                    if (data && data.data.code == 1) {
                        resolve(data.data)
                    }
                })
                .catch(err => {
                    console.log(err);
                })
        })
    },
    // 获取手机验证码
    getMCode({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.userHttps.api}/apiuser/login/getcode`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },
    getPhoneCode({ rootState, commit }, opt) {
        return new Promise((resolve, reject) => {//获取手机验证码
            api.post(`https://loginf.lawxp.com/Auth/APPSendCode`, opt).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    // 核对手机验证码
    checkCode({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.userHttps.api}/apiuser/login/checkcode`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },

    // 手机验证码登录
    verificationLogin({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.userHttps.api}/apiuser/login/verificationlogin`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },

    // 获取用户信息
    getUserInfoApi({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/users/getinfos`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },

    //修改密码 
    upDataPassword({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/users/updatepwd`, opt,{
                headers:{
                    Authorization:'Bearer '+localStorage.getItem("Beitoken")
                  },
            }).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },

    // 获取总金额和可提现金额
    getWithdrawable({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/order/statistics`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },

    // 更新用户信息 ，（修改店铺名称）
    upDataUserInfoForm({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/users/updateinfo`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },

    // 设置提现帐户信息
    setAccountInfo({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/users/setaccount`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },

    // 申请提现
    applyWithdrawal({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/withdraw/applywithdrawal`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },

    // 获取当前帐户信息
    getAccountApi({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/withdraw/getaccount`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },

    // 获取申请提现日志
    getLogsList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/withdraw/getlogslist`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },


    // 是否是平台用户
    isUser({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apiuser/login/isuser`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    },
    //获取北京的登录接口的token
    BUserInfoLoginPhone({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.BeiHttps.api}Auth/GteTokenByAccountPwd`, opt).then(res => {
                if (res) {
                    resolve(res)
                }
            }).catch(err => {
                console.log(err);
            })
        })
    }



}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}